"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chunk = void 0;
/**
 * Split an array into chunks
 *
 * @param arr array
 * @param size chunk size
 */
const chunk = (arr, size) => {
    return [...Array(Math.ceil(arr.length / size))].map((_, i) => arr.slice(size * i, size + size * i));
};
exports.chunk = chunk;
//# sourceMappingURL=arrayUtils.js.map